var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-autocomplete',{staticStyle:{"width":"100%"},attrs:{"fetch-suggestions":_vm.testNumberSearch,"placeholder":"请输入号码"},on:{"input":_vm.inputNumber,"select":_vm.testNumberSelect},model:{value:(_vm.testNumber),callback:function ($$v) {_vm.testNumber=$$v},expression:"testNumber"}})
}
var staticRenderFns = []

export { render, staticRenderFns }